// Kannada — shared key set with the Flutter apps (lib/l10n).
// Auto-generated from the Dart source of truth; keep both in sync.
// Flat, dotted keys — i18n is configured with keySeparator:false.

const kn: Record<string, string> = {
  "common.save": "ಉಳಿಸಿ",
  "common.cancel": "ರದ್ದುಮಾಡಿ",
  "common.delete": "ಅಳಿಸಿ",
  "common.edit": "ಸಂಪಾದಿಸಿ",
  "common.add": "ಸೇರಿಸಿ",
  "common.close": "ಮುಚ್ಚಿ",
  "common.back": "ಹಿಂದೆ",
  "common.done": "ಮುಗಿದಿದೆ",
  "common.yes": "ಹೌದು",
  "common.no": "ಇಲ್ಲ",
  "common.confirm": "ದೃಢೀಕರಿಸಿ",
  "common.search": "ಹುಡುಕಿ",
  "common.retry": "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
  "common.loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
  "common.offline": "ಆಫ್‌ಲೈನ್",
  "nav.settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
  "nav.orders": "ಆರ್ಡರ್‌ಗಳು",
  "nav.tables": "ಟೇಬಲ್‌ಗಳು",
  "nav.menu": "ಮೆನು",
  "nav.reports": "ವರದಿಗಳು",
  "roles.pos": "ಪಾಯಿಂಟ್ ಆಫ್ ಸೇಲ್",
  "roles.kds": "ಅಡುಗೆಮನೆ ಪ್ರದರ್ಶನ",
  "roles.customer": "ಗ್ರಾಹಕ ಪ್ರದರ್ಶನ",
  "roles.captain": "ಕ್ಯಾಪ್ಟನ್",
  "roles.kiosk": "ಸ್ವಯಂ-ಆರ್ಡರ್ ಕಿಯೋಸ್ಕ್",
  "order.dineIn": "ಡೈನ್-ಇನ್",
  "order.takeaway": "ಟೇಕ್‌ಅವೇ",
  "order.delivery": "ಡೆಲಿವರಿ",
  "order.quickBill": "ಕ್ವಿಕ್ ಬಿಲ್",
  "order.newOrder": "ಹೊಸ ಆರ್ಡರ್",
  "order.sendToKitchen": "ಅಡುಗೆಮನೆಗೆ ಕಳುಹಿಸಿ",
  "order.addItem": "ವಸ್ತು ಸೇರಿಸಿ",
  "order.cart": "ಕಾರ್ಟ್",
  "order.empty": "ಇನ್ನೂ ಯಾವುದೇ ವಸ್ತುಗಳಿಲ್ಲ",
  "bill.settle": "ಬಿಲ್ ಸೆಟಲ್ ಮಾಡಿ",
  "bill.subtotal": "ಉಪ-ಮೊತ್ತ",
  "bill.discount": "ರಿಯಾಯಿತಿ",
  "bill.total": "ಒಟ್ಟು",
  "bill.gst": "ಜಿಎಸ್‌ಟಿ",
  "bill.customerName": "ಗ್ರಾಹಕರ ಹೆಸರು",
  "bill.token": "ಟೋಕನ್",
  "bill.billNo": "ಬಿಲ್ ಸಂಖ್ಯೆ",
  "bill.splitBill": "ಬಿಲ್ ವಿಭಜಿಸಿ",
  "bill.splitBySeat": "ಸೀಟಿನ ಪ್ರಕಾರ ವಿಭಜಿಸಿ",
  "bill.pay": "ಪಾವತಿಸಿ",
  "bill.print": "ಮುದ್ರಿಸಿ",
  "bill.paid": "ಪಾವತಿಸಲಾಗಿದೆ",
  "bill.pending": "ಬಾಕಿ ಇದೆ",
  "table.free": "ಖಾಲಿ",
  "table.occupied": "ಭರ್ತಿಯಾಗಿದೆ",
  "table.transfer": "ವರ್ಗಾಯಿಸಿ",
  "table.merge": "ವಿಲೀನಗೊಳಿಸಿ",
  "settings.language": "ಭಾಷೆ",
  "settings.tax": "ತೆರಿಗೆ",
  "settings.printing": "ಮುದ್ರಣ",
  "settings.account": "ಖಾತೆ & ಯೋಜನೆ",
  "settings.general": "ಸಾಮಾನ್ಯ",
  "settings.deviceMode": "ಸಾಧನ ಮೋಡ್",
  "settings.chooseLanguage": "ಭಾಷೆಯನ್ನು ಆರಿಸಿ",
  "nav.order": "ಆರ್ಡರ್",
  "nav.online": "ಆನ್‌ಲೈನ್",
  "nav.activity": "ಚಟುವಟಿಕೆ",
  "nav.history": "ಇತಿಹಾಸ",
  "nav.import": "ಆಮದು",
  "nav.endShift": "ಶಿಫ್ಟ್ ಮುಗಿಸಿ",
  "settings.title": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
  "settings.subtitle": "ಔಟ್‌ಲೆಟ್, ತೆರಿಗೆ, ಪ್ರಿಂಟರ್‌ಗಳು, ಪಾತ್ರಗಳು & ಬಿಲ್ ಸ್ವರೂಪ",
  "settings.sectionOutlet": "ಔಟ್‌ಲೆಟ್ & ಬ್ರಾಂಡಿಂಗ್",
  "settings.sectionTax": "ತೆರಿಗೆ & ಜಿಎಸ್‌ಟಿ",
  "settings.sectionPrinters": "ಪ್ರಿಂಟರ್‌ಗಳು & ಕೆಒಟಿ",
  "settings.sectionRoles": "ಪಾತ್ರಗಳು & ಅನುಮತಿಗಳು",
  "settings.sectionBillFormat": "ಬಿಲ್ ಸ್ವರೂಪ",
  "settings.sectionChannels": "ಆನ್‌ಲೈನ್ ಚಾನೆಲ್‌ಗಳು",
  "settings.sectionAccount": "ಖಾತೆ & ಯೋಜನೆಗಳು",
  "settings.sectionAbout": "ಕುರಿತು & ನವೀಕರಣಗಳು",
  "order.viewCart": "ಕಾರ್ಟ್ ನೋಡಿ",
  "order.categories": "ವರ್ಗಗಳು",
  "order.tapToBuild": "ಆರ್ಡರ್ ರಚಿಸಲು ಭಕ್ಷ್ಯಗಳನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ",
  "order.addNote": "ಟಿಪ್ಪಣಿ ಸೇರಿಸಿ",
  "order.searchDishes": "ಭಕ್ಷ್ಯಗಳನ್ನು ಹುಡುಕಿ",
  "bill.settleAndPrint": "ಸೆಟಲ್ ಮಾಡಿ & ಮುದ್ರಿಸಿ",
  "menu.title": "ಮೆನು & ವಸ್ತುಗಳು",
  "menu.searchItems": "ವಸ್ತುಗಳನ್ನು ಹುಡುಕಿ…",
  "menu.noItems": "ಇಲ್ಲಿ ಯಾವುದೇ ವಸ್ತುಗಳಿಲ್ಲ",
  "menu.addItemBtn": "ವಸ್ತು ಸೇರಿಸಿ",
  "menu.tapAddItem": "ರಚಿಸಲು “ವಸ್ತು ಸೇರಿಸಿ” ಟ್ಯಾಪ್ ಮಾಡಿ",
  "menu.addCategory": "ವರ್ಗ ಸೇರಿಸಿ",
  "menu.newCategory": "ಹೊಸ ವರ್ಗ",
  "order.allFired": "ಎಲ್ಲವೂ ಕಳುಹಿಸಲಾಗಿದೆ",
  "bill.settling": "ಸೆಟಲ್ ಆಗುತ್ತಿದೆ…"
};

export default kn;
